import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {translate} from 'views/module';

import userUtil from 'utils/miscellaneous/user/user_util';
import moment from 'moment';

const ChatMessageList = (props) => {
  const {
    selectedChatMessages,
    selectedParticipantRn,
  } = props;
  const bottomRef = React.useRef(null);

  React.useEffect(() => {
    if (selectedChatMessages.length === 0) return;

    bottomRef.current?.scrollIntoView({block: 'end'});
  }, [selectedChatMessages]);

  return (
    <Stack sx={{gap: 1}}>
      {
        selectedChatMessages.map((message) => {
          const isCaregiver = message.requesterRn === selectedParticipantRn;
          const requesterName = userUtil.getFullName(
              message.requester?.firstName,
              message.requester?.lastName,
          ).trim() || translate('case.Communication.Chat.UnknownSender');

          return (
            <Stack
              key={message.messageRn || `${message.requesterRn}-${message.createdAt}`}
              alignItems={isCaregiver ? 'flex-end' : 'flex-start'}
            >
              <Box
                sx={{
                  maxWidth: '88%',
                  border: '1px solid',
                  borderColor: isCaregiver ? '#F2B69E' : '#ECECF1',
                  borderRadius: '9px',
                  backgroundColor: isCaregiver ? '#FFF4EE' : '#FFFFFF',
                  p: '10px 13px',
                }}
              >
                <Stack sx={{gap: 0.5}}>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#63708A',
                    }}
                  >
                    {requesterName}
                  </Typography>
                  {
                    message.messageText && (
                      <Typography
                        sx={{
                          fontSize: '13px',
                          fontWeight: 400,
                          color: '#050A14',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {message.messageText}
                      </Typography>
                    )
                  }
                  {
                    Array.isArray(message.files) && message.files.length > 0 && (
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: 500,
                          color: '#63708A',
                        }}
                      >
                        {translate('case.Communication.Chat.AttachmentCount', {count: message.files.length})}
                      </Typography>
                    )
                  }
                  {
                    message.createdAt && (
                      <Typography
                        sx={{
                          fontSize: '11px',
                          fontWeight: 400,
                          color: '#9A9BAE',
                        }}
                      >
                        {moment(message.createdAt).format('MMM D, h:mm A')}
                      </Typography>
                    )
                  }
                </Stack>
              </Box>
            </Stack>
          );
        })
      }
      <div ref={bottomRef} />
    </Stack>
  );
};

ChatMessageList.propTypes = {
  selectedChatMessages: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedParticipantRn: PropTypes.string,
};

export default React.memo(ChatMessageList);
